import { GET_TAGS, TAG_ERROR } from "../types";

const TagReducer = (state, action) => {
  switch (action.type) {
    case GET_TAGS:
      const tags = action.payload;
      const res_tags = tags.map((tag) => {
        const ret = {};
        ret["name"] = tag.name;
        ret["title"] = tag.name;
        ret["created_at"] = tag.created_at;
        ret["updated_at"] = tag.updated_at;
        ret["id"] = tag.id;
        return ret;
      });
      return {
        ...state,
        tags: res_tags,
        loading: false,
      };
    case TAG_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default TagReducer;